import { SelectInputOption } from '@/components/form/baseInputs/inputTypes';
import { COLLABORATOR_KIND_DISPLAY_NAMES } from '@/modules/collaborators/collaborators.constants';
import { CollaboratorKind } from '@/types/schema';

export interface CollaboratorFormShape {
  firstName: string;
  lastName: string;
  email: string;
  role: CollaboratorKind | '';
  roleId: string;
  title: string;
  organization: string;
  associatedClientIds: string[];
  _previousHouseholdIds: string[];
  _originalRoleId?: string;
}

export const defaultValues: CollaboratorFormShape = {
  firstName: '',
  lastName: '',
  email: '',
  role: '',
  roleId: '',
  title: '',
  organization: '',
  associatedClientIds: [],
  _previousHouseholdIds: [],
  _originalRoleId: '',
};

export const ROLE_OPTION_ITEMS: SelectInputOption[] = [
  {
    display: COLLABORATOR_KIND_DISPLAY_NAMES.ATTORNEY,
    value: CollaboratorKind.Attorney,
  },
  { display: COLLABORATOR_KIND_DISPLAY_NAMES.CPA, value: CollaboratorKind.Cpa },
  {
    display: COLLABORATOR_KIND_DISPLAY_NAMES.CLIENT,
    value: CollaboratorKind.Client,
  },
  {
    display: COLLABORATOR_KIND_DISPLAY_NAMES.FINANCIAL_ADVISOR,
    value: CollaboratorKind.FinancialAdvisor,
  },
  {
    display: COLLABORATOR_KIND_DISPLAY_NAMES.OTHER,
    value: CollaboratorKind.Other,
  },
];
